import { render, staticRenderFns } from "./StudentUnfinishedModules.vue?vue&type=template&id=22da5d9d"
import script from "./StudentUnfinishedModules.vue?vue&type=script&lang=js"
export * from "./StudentUnfinishedModules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports